import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Sun, Moon } from "lucide-react";
import logo from "../assets/logo.png";
import "../styles/navbar.css";

function Navbar() {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [darkMode, setDarkMode] = useState(() => {
        const saved = localStorage.getItem("theme");
        if (saved) return saved === "dark";
        return window.matchMedia("(prefers-color-scheme: dark)").matches;
    });

    useEffect(() => {
        if (darkMode) {
            document.body.classList.add("dark-mode");
            localStorage.setItem("theme", "dark");
        } else {
            document.body.classList.remove("dark-mode");
            localStorage.setItem("theme", "light");
        }
    }, [darkMode]);

    useEffect(() => {
        const checkAuth = () => {
            const stored = localStorage.getItem("vblog_user");
            setUser(stored ? JSON.parse(stored) : null);
        };

        checkAuth();
        window.addEventListener("authChange", checkAuth);
        return () => window.removeEventListener("authChange", checkAuth);
    }, []);
    return (
        <nav className="navbar">
            <div className="logo-container" onClick={() => navigate("/")}>
                <img src={logo} alt="VBlogAI Logo" className="navbar-logo-img" />
            </div>

            <div className="menu">
                <NavLink
                    to="/"
                    className={({ isActive }) => isActive ? "active" : ""}
                >
                    Home
                </NavLink>

                <NavLink
                    to="/tools"
                    className={({ isActive }) => isActive ? "active" : ""}
                >
                    AI Tools
                </NavLink>

                <NavLink
                    to="/how-tos"
                    className={({ isActive }) => isActive ? "active" : ""}
                >
                    How-To's
                </NavLink>

                <NavLink
                    to="/tutorials"
                    className={({ isActive }) => isActive ? "active" : ""}
                >
                    Tutorials
                </NavLink>

                <NavLink
                    to="/blogs"
                    className={({ isActive }) => isActive ? "active" : ""}
                >
                    Blogs
                </NavLink>
            </div>

            <div className="nav-buttons">
                {/* Theme Toggle Button */}
                <button 
                    className="theme-toggle-btn"
                    onClick={() => setDarkMode(!darkMode)}
                    title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
                >
                    {darkMode ? <Sun size={18} /> : <Moon size={18} />}
                </button>

                <Link to="/submit" style={{ textDecoration: 'none' }}>
                    <button className="join-btn">+ Submit Tool</button>
                </Link>
                
                {user ? (
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <Link to="/profile" style={{ textDecoration: 'none' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                fontSize: '16px',
                                cursor: 'pointer',
                                boxShadow: '0 4px 10px rgba(99, 102, 241, 0.3)',
                                border: '2px solid rgba(255, 255, 255, 0.1)',
                                transition: 'transform 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                            onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                            title={user.name}
                            >
                                {user.name ? user.name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) : "U"}
                            </div>
                        </Link>
                    </div>
                ) : (
                    <Link to="/signin" style={{ textDecoration: 'none' }}>
                        <button className="sign-btn">Sign In</button>
                    </Link>
                )}
            </div>
        </nav>
    );
}

export default Navbar;